var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product-carousel" },
    [
      _c(
        "ACarousel",
        { staticClass: "swiper", attrs: { options: _vm.carouselSettings } },
        _vm._l(_vm.images, function (item, imageIndex) {
          return _c(
            "ACarouselSlide",
            { key: imageIndex, attrs: { index: imageIndex } },
            [
              _c("div", { staticClass: "image-container" }, [
                _c(
                  "div",
                  { staticClass: "image" },
                  [
                    _c("AImage", {
                      attrs: {
                        img: item,
                        cover: false,
                        contain: "",
                        preset: "wineproductdetails",
                        ratio: "3-4",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }